import { TimeOfDayField } from './TimeOfDayField';
import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';

export const days = Array.from({ length: 7 }, (x, i) => i);
export const hours = Array.from({ length: 24 }, (x, i) => i);

export default function TimeOfWeek() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();

    return (
        <div className='mt-4 w-80'>
            <label
                htmlFor='timeOfDay'
                className='block text-sm font-medium text-gray-700'
            >
                Time of week
            </label>

            <TimeOfDayField
                columns={days}
                rows={hours}
                selected={forecastingSettings.hourOfWeekFilter}
                onChange={(hourOfWeekFilter) => updateForecastingSetting({ hourOfWeekFilter: hourOfWeekFilter })}
                colDisplay={it => ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][it]}
                rowDisplay={it => `${`${it}`.padStart(2, '0')}:00`}
                isDisabled={isPrimaryForecastingLoading}
            />
        </div>
    );
}
